<template>
    <v-app id="fusedship">
        <v-app-bar app color="#004AAD" dark class="fusedship-header" min-height="100" fixed fluid>

            <v-toolbar-title>
                <router-link to="/">
                    <v-img src="/images/machship-logo-reversed.svg" alt="MachShip" contain width="170"></v-img>
                </router-link>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-autocomplete class="ml-3 choose-integration"
                label="Choose Integration" single-line hide-details style="max-width: 200px" :items="integrations"
                v-model="integrationFilter" @change="onChangeIntegration" v-if="$vuetify.breakpoint.mdAndUp">
            </v-autocomplete>

            <div class="top-search ml-4" v-if="$vuetify.breakpoint.mdAndUp">
                <v-text-field append-icon="search" label="Search Consignments" single-line hide-details
                    :model="search" @change="onSearch($event)">
                </v-text-field>
            </div>


            <v-app-bar-nav-icon @click="drawer = !drawer" class="d-md-none"></v-app-bar-nav-icon>

            <template v-slot:extension>
                <div class="d-flex align-center w-100" v-if="$vuetify.breakpoint.mdAndUp">
                    <MenuItems v-if="menus && menus.length > 0" :items="menuSyncs" horizontal />
                    <v-spacer></v-spacer>
                    <v-menu v-if="user" bottom min-width="200px" rounded offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn small text v-on="on">
                                {{ user.name }}
                            </v-btn>
                        </template>
                        <v-card>
                            <v-list-item-content class="justify-center">
                                <div class="mx-auto text-center">
                                    <v-avatar color="primary">
                                        <span class="white--text headline">{{ user.name | initials }}</span>
                                    </v-avatar>
                                    <h3>{{ user.name }}</h3>
                                    <p class="caption mt-1 p-1">
                                        {{ user.email }}
                                    </p>
                                    <v-divider class="my-3" v-if="isAdmin"></v-divider>
                                    <MenuItems :items="menuAdmin" />
                                    <v-divider class="my-3"></v-divider>
                                    <v-btn depressed rounded text :to="{ name: 'password-update' }">
                                        Update Password
                                    </v-btn>
                                    <v-btn depressed rounded text :to="{ name: 'two-factor-setup' }">
                                        Setup 2FA
                                    </v-btn>
                                    <v-btn depressed rounded text @click="onSignout">
                                        Logout
                                    </v-btn>
                                </div>
                            </v-list-item-content>
                        </v-card>
                    </v-menu>
                </div>

                <div v-if="$vuetify.breakpoint.smAndDown" class="d-flex align-center">
                    <v-autocomplete class="choose-integration"
                        label="Choose Integration" single-line hide-details style="max-width: 200px" :items="integrations"
                        v-model="integrationFilter" @change="onChangeIntegration">
                    </v-autocomplete>

                    <div class="top-search ml-4">
                        <v-text-field append-icon="search" label="Search Consignments" single-line hide-details
                            :model="search" @change="onSearch($event)">
                        </v-text-field>
                    </div>
                </div>
            </template>

        </v-app-bar>

        <!-- Mobile Navigation -->
        <v-navigation-drawer v-model="drawer" app temporary class="d-md-none" style="z-index: 99;">
            <v-list nav>
                <MenuItems v-if="menus && menus.length > 0" :items="menuSyncs" />
                <v-divider></v-divider>
                <v-list-item v-if="user">
                    <v-list-item-avatar>
                        <v-avatar color="primary">
                            <span class="white--text headline">{{ user.name | initials }}</span>
                        </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title>{{ user.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                <v-divider v-if="isAdmin"></v-divider>
                <MenuItems v-if="isAdmin" :items="menuAdmin" />
                <v-divider></v-divider>
                <v-list-item :to="{ name: 'password-update' }">
                    <v-list-item-title>Update Password</v-list-item-title>
                </v-list-item>
                <v-list-item @click="onSignout">
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>

        <v-main>
            <v-container fluid>
                <v-row align="start">
                    <v-col>
                        <v-breadcrumbs
                            :items="items"
                            class="p-0 mt-3 mb-3 breadcrumbs-container"
                        >
                            <template v-slot:item="{ item }">
                                <v-breadcrumbs-item
                                    :to="item.path"
                                    :exact="true"
                                    :disabled="item.disabled"
                                    class="breadcrumb-item"
                                >
                                    {{ item.name.toUpperCase() }}
                                </v-breadcrumbs-item>
                            </template>
                            <template v-slot:divider>
                                <i class="fa fa-chevron-right"></i>
                            </template>
                        </v-breadcrumbs>
                        <div>
                            <slot />
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>


        <v-snackbar v-model="info.isShow" :color="info.color" :multi-line="true" :right="true" :timeout="10000"
            :top="true" class="pt-0">
            <div v-html="info.message"></div>
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="info.isShow = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>
        <v-overlay :value="overlay" :z-index="999">
            <v-progress-circular indeterminate size="128">
                {{ overlayMessage }}
            </v-progress-circular>

        </v-overlay>

        <security-setup-modal
            v-model="showSecurityModal"
            :password-updated="user ? Boolean(user.password_changed_at) : false"
        />
    </v-app>
</template>

<script>
import { EventBus } from '../event-bus.js'
import http from '../http.js'
import MenuItems from './ui/MenuItems'
import SkeletonMenuItems from './ui/SkeletonMenuItems'
import SecuritySetupModal from '../components/SecuritySetupModal.vue'

export default {

    filters: {
        initials(name) {
            return name ? name.split(' ').map(str => str.charAt(0)).join('') : ''
        }
    },

    components: {
        MenuItems,
        SkeletonMenuItems,
        SecuritySetupModal
    },

    data() {
        return {
            home: { path: '/', name: 'dashboard', disabled: false },
            items: [],
            overlay: false,
            overlayMessage: '',

            // toast information
            info: {
                isShow: false,
                message: '',
                color: 'dark'
            },

            drawer: true,
            miniVariant: false,
            isAdmin: false,
            integrationFilter: null,

            search: '',
            securityModalVisible: false
        }
    },

    created() {
        http.install()
        this.onInit()

        // Listen to the event.
        EventBus.$on('show-info', this.showInfo);
        EventBus.$on('show-error', this.showError);
        EventBus.$on('show-success', this.showSuccess);
        EventBus.$on('password-updated', this.onPasswordUpdated);
        EventBus.$on('two-factor-confirmed', this.onTwoFactorConfirmed);
        EventBus.$on('two-factor-disabled', this.onTwoFactorDisabled);
    },

    beforeDestroy() {
        EventBus.$off('show-info', this.showInfo);
        EventBus.$off('show-error', this.showError);
        EventBus.$off('show-success', this.showSuccess);
        EventBus.$off('password-updated', this.onPasswordUpdated);
        EventBus.$off('two-factor-confirmed', this.onTwoFactorConfirmed);
        EventBus.$off('two-factor-disabled', this.onTwoFactorDisabled);
    },

    watch:{
        $route (to, from){
            if (to.name != from.name) {
                this.checkBreadcrumbs()

                // This only works for admin
                if (
                    this.$store.getters.isAdmin &&
                    to.query &&
                    to.query.filter &&
                    to.query.filter != this.integrationFilter
                ) {
                    this.integrationFilter = to.query.filter
                }
            }
        },

        user: {
            handler(to, from) {
                this.isAdmin = this.$store.getters.isAdmin
                this.onFetchAllIntegratins()

                if (!this.isAdmin && to && to.integration_ids) {
                    this.integrationFilter = to.integration_ids[0]
                }

                // Initialize security modal visibility based on user data
                if (to) {
                    this.securityModalVisible = (!to.password_changed_at || !to.two_factor_confirmed_at) &&
                                              this.$route.name !== 'password-update' &&
                                              this.$route.name !== 'two-factor-setup';
                }
            }
        },

        integrationFilter (to, from) {
            if (to != from) {
                this.$store.dispatch('setActiveIntegration', to)

                // 1. need to get the integration
                const integData = this.$store.state.integrations.find(integ => integ.id == to)
                if (integData) {
                    // setIsTest of that integration
                    this.$store.dispatch('setIsTestIntegration', integData.attributes.is_test == 1)
                } else {
                    this.$store.dispatch('setIsTestIntegration', false)
                }

            }
        },
    },

    computed: {
        path() {
            return this.$route.path
        },

        menuIncidents() {
            return []
        },

        menuSyncs() {
            let menus = this.$store.getters.getMenus
            return menus ? menus.filter(menu => menu.group == 'syncs' && menu.title !== 'Dashboard') : []
        },

        menuLiverates() {
            let menus = this.$store.getters.getMenus
            return menus ? menus.filter(menu => menu.group == 'liverates') : []
        },

        menuAdmin() {
            let menus = this.$store.getters.getMenus
            return menus ? menus.filter(menu => menu.group == 'admin') : []
        },

        menus() {
            return this.$store.getters.getMenus
        },

        user() {
            return this.$store.state.user;
        },

        integrations() {
            if (this.$store.state.integrations.length > 0) {
                let mapped = this.$store.state.integrations.map(item => {
                    return {
                        text: item.attributes.label,
                        value: item.id
                    }
                })

                mapped.unshift({
                    text: 'ALL',
                    value: ''
                })

                return mapped
            }
            return []
        },

        integrationLabel() {
            if (this.integrationFilter && this.integrations) {
                let integration = this.integrations.find(integ => integ.value == this.integrationFilter)
                return integration ? integration.text : null
            }

            return null
        },

        showSecurityModal: {
            get() {
                if (!this.user) return false;
                // Don't show security modal in local environment
                if (this.user.user_environment === 'local') return false;

                return this.securityModalVisible &&
                       (!this.user.password_changed_at || !this.user.two_factor_confirmed_at) &&
                       this.$route.name !== 'password-update' &&
                       this.$route.name !== 'two-factor-setup';
            },
            set(value) {
                this.securityModalVisible = value;
                // If they somehow close the modal, reopen it unless they're on one of the setup pages
                // and we're not in local environment
                if (!value &&
                    this.$route.name !== 'password-update' &&
                    this.$route.name !== 'two-factor-setup') {
                    setTimeout(() => {
                        if (this.user &&
                            this.user.user_environment !== 'local' &&
                            (!this.user.password_changed_at || !this.user.two_factor_confirmed_at)) {
                            this.$nextTick(() => {
                                this.securityModalVisible = true;
                            });
                        }
                    }, 0);
                }
            }
        }
    },

    methods: {
        // init
        onInit() {
            this.overlay = true
            this.overlayMessage = 'Initializing..'
            this.$http
                .post('api/checkauth')
                .then(({data}) => {
                    let user = data.data.attributes
                    user.id = data.data.id
                    this.overlay = false
                    this.$store.dispatch('setUser', user)
                })
                .catch(err => {
                    this.overlay = false
                    this.showError(err)
                })

            this.checkBreadcrumbs()
        },

        onChangeIntegration() {
            // show something that the admin changed the active integrations
            // this.showSuccess('Active Integration changed, you will be reloaded after 3 seconds.')
            // setTimeout(() => {
            // window.location = window.location.pathname;
            // }, 200)
        },

        onFetchAllIntegratins() {
            // get a list of integrations if its an admin
            // if (this.isAdmin) {
                this.$http
                    .get('/api/integrations/selections', { params: { limit: -1 } })
                    .then( ({ data }) => {
                        this.$store.dispatch('setIntegrations', data.data)

                        const activeInteg = this.$store.getters.getActiveIntegration
                        if (activeInteg) {
                            const integData = this.$store.state.integrations.find(integ => integ.id == activeInteg)
                            if (integData) {
                                this.$store.dispatch('setIsTestIntegration', integData.attributes.is_test == 1)
                            }
                        }

                    })
                    .catch( err => {
                        this.showError(err)
                    })
            // }
        },

        // on signing out
        onSignout() {
            this.overlay = true
            this.overlayMessage = 'Signing out...'
            setTimeout(function() {
                this.$http
                    .post('api/auth/logout')
                    .then(({data}) => {
                        localStorage.removeItem('jwt')
                        localStorage.removeItem('active_integration')
                        localStorage.removeItem('is_test_integration')
                        window.location.href = '/login'
                    })
                    .catch(err => {
                        this.overlay = false
                        this.showError(err)
                    })
            }.bind(this), 1000)
        },

        // TODO to improve routes breadcrumbs handling
        checkBreadcrumbs() {
            let routes = this.$route.matched;

            // reset and insert home default
            this.home.disabled = false
            this.items = []
            this.items.push(this.home);

            // iterate matched routes
            routes.forEach(route => {
                // validate routes if already existing
                if (route.name && route.name != '' && this.items.findIndex(item => item.name == route.name) == -1) {
                    this.items.push(route);
                }
            })

            this.items[this.items.length - 1].disabled = true
        },


        showSuccess(message) { this.showInfo(message, '#5d5'); },
        showError(message) {
            if (typeof message == 'object') {
                message = this.getErrors(message)
            }
            this.showInfo(message, '#d55');
        },
        showInfo(data, color = 'dark') {
            if (typeof data == 'object') {
                this.info.message = data.message
                this.info.color = data.color ? data.color : color
            } else {
                this.info.message = data
                this.info.color = color
            }

            this.info.isShow = true
        },



        onSearch(text) {
            this.$router.push('/logs?' + (new URLSearchParams({ search: text })));
        },

        onPasswordUpdated() {
            // Just refresh user data to update the modal state
            this.onInit();
        },

        onTwoFactorConfirmed() {
            // Just refresh user data to update the modal state
            this.onInit();
        },

        onTwoFactorDisabled() {
            // Refresh user data and show security modal
            this.onInit();
            this.securityModalVisible = true;
        },
    }
};
</script>

<style scoped>
.breadcrumbs-container {
    display: flex;
    align-items: center;
    flex-wrap: nowrap; /* Prevents line breaks */
    overflow-x: auto;  /* Allows horizontal scrolling if needed */
    white-space: nowrap;
    font-size: 14px; /* Default desktop size */
}

.breadcrumb-item {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 100%;
    font-size: inherit; /* Inherit from parent */
}

/* Hide scrollbar on WebKit browsers */
.breadcrumbs-container::-webkit-scrollbar {
    display: none;
}

/* 📱 Adjustments for Mobile */
@media (max-width: 768px) { /* Targets tablets & mobile */
    .breadcrumbs-container {
        font-size: 12px !important; /* Shrink for mobile */
    }
    .breadcrumb-item {
        font-size: 12px !important;
    }
}

</style>
